import { makeActionCreator } from '../../config/store/utils'
import { batch } from 'react-redux'
import { getLatestPoints } from '../../services/keplerServices'

// Action types
export const GET_CESIUM = 'GET_CESIUM'
export const GET_CESIUM_ERROR = 'GET_CESIUM_ERROR'
export const GET_CESIUM_SUCCESS = 'GET_CESIUM_SUCCESS'

// Action creators
export const onGetCesium = makeActionCreator(GET_CESIUM)
export const onGetCesiumError = makeActionCreator(GET_CESIUM_ERROR, 'payload')
export const onGetCesiumSuccess = makeActionCreator(GET_CESIUM_SUCCESS, 'payload')

// Thunk
export const onGetCesiumThunk = () => async (dispatch, getState) => {
  dispatch(onGetCesium())

  try {
    const {
      apis: {
        base: { apiKey, apiName }
      }
    } = getState().auth

    // Fetch latest points directly (no date input needed)
    const { data: latestPoints } = await getLatestPoints({
      apiKey: apiKey,
      apiName: `${apiName}_V2`
    })

    // Handle case when no data is returned
    const urlData = Array.isArray(latestPoints) ? latestPoints : []

    return batch(() => {
      dispatch(onGetCesiumSuccess({ urlData }))
    })
  } catch (error) {
    return dispatch(onGetCesiumError({ error }))
  }
}
